import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import Button from '../Button/Button';
import Icon from '../Icon/Icon';
import { Flex } from '../Layout/Layout';

const HeaderWrapper = styled(Flex)`
  position: relative;
  background-color: ${props => props.theme.colors.white};
`;

const NavigationButton = styled(Button)`
  padding: 15px;
  position: relative;
  z-index: ${props => props.theme.zIndex.header};

  svg {
    width: 40px;
    height: 40px;
  }

  &:after {
    content: '';
    height: 60%;
    border-right: 1px solid ${props => props.theme.colors.xDarkgray};
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }

  ${props =>
    props.hidden &&
    css`
      display: none;
    `};
`;

const LogoWrapper = styled.div`
  position: relative;
  text-align: center;

  svg {
    width: 100px;
    margin: 20px;
  }
`;

const ChildrenWrapper = styled.div`
  position: relative;
  bottom: 0;
  left: 0;
  width: 100%;
  color: ${props => props.theme.colors.white};
  /* border: 1px solid red; */
`;

const Header = props => (
  <HeaderWrapper width={1 / 1}>
    <NavigationButton onClick={props.menuClick}>
      <Icon id="hamburger" fillColor={props => props.theme.colors.primary} />
    </NavigationButton>

    <LogoWrapper>
      <Icon id="ugent" />
    </LogoWrapper>

    {props.children && <ChildrenWrapper>{props.children}</ChildrenWrapper>}
  </HeaderWrapper>
);

Header.propTypes = {
  menuClick: PropTypes.func
};

export default Header;
